import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import axios from '../../util/Api';

const DepartmentForm = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/master/departments`;
    axios.get(url).then(resp => {
      setDepartments(resp.data);
      setLoading(false);
    }).catch(err => {});
  }, []);

  return (
    <>
      <Select
        defaultValue={formik.values.department} onChange={value => formik.setFieldValue("department", value)}
        placeholder="Pilih departemen"
        loading={loading}
      >
        {departments.map((item, key) => {
          return <Select.Option value={item.id} key={`department-${key}`}>{item.name}</Select.Option>
        })}
      </Select>
      <ErrorMessage component="div" name="department" className="gx-mt-2 gx-text-red" />
    </>
  );
}

export default DepartmentForm;